import React from 'react';
import { Box, Divider } from '@mui/material';
import ProfileForm from 'app/form/ProfileForm';

const ProductSection = () => {
	return (
		<div>
			<ProfileForm />
		</div>
	);
};

export default ProductSection;
